// LF360-2044: searching and filtering the roles list. At most 53 roles, so
// it is done here rather than by the server.

export const TYPE_OPTIONS = [
  { id: "builtIn", name: "Built-in" },
  { id: "custom", name: "Custom" },
];

export const SITE_SCOPING_OPTIONS = [
  { id: "limited", name: "Limited to their sites" },
  { id: "whole", name: "Whole project" },
];

export const siteScopingLabel = (value) =>
  SITE_SCOPING_OPTIONS.find((o) => o.id === value)?.name || value;

/**
 * Roles matching the search (name or description) and the filters: a role
 * matches a filter when it has any of the picked types or scopings, and every
 * picked permission.
 */
export function filterRoles(roles, { search = "", filters = {} } = {}) {
  const query = search.trim().toLowerCase();
  const types = filters.type || [];
  const scopings = filters.siteScoping || [];
  const permissions = filters.permission || [];

  return roles.filter((role) => {
    if (
      query &&
      !(role.name || "").toLowerCase().includes(query) &&
      !(role.description || "").toLowerCase().includes(query)
    ) {
      return false;
    }
    if (types.length && !types.includes(role.type)) return false;
    if (scopings.length && !scopings.includes(role.siteScoping)) return false;
    if (permissions.length && !permissions.every((key) => (role.permissions || []).includes(key))) {
      return false;
    }
    return true;
  });
}
